<i18n>
  {
    "fr": {
      "contact-us": "Contactez nous",
      "contact-dialog": {
        "title": "Contact",
        "phone": "Par téléphone",
        "amplitudes-phone": "05 67 20 74 40",
        "email": "Par email",
        "amplitudes-email": "airbus@amplitudes.com"
      },
      "language": "Langage",
      "fr": "Français",
      "en": "Anglais"
    },
    "en": {
      "contact-us": "Contact us",
      "contact-dialog": {
        "title": "Contact",
        "phone": "By phone",
        "amplitudes-phone": "05 67 20 74 40",
        "email": "By e-mail",
        "amplitudes-email": "airbus@amplitudes.com"
      },
      "language": "Language",
      "fr": "French",
      "en": "English"
    }
  }
</i18n>

<template>
  <div>
    <v-app-bar
      height="80px"
      max-height="80px"
      color="white"
    >
      <button @click="returnHome">
        <v-img
          id="logo-aisc"
          v-ripple
          class="d-inline-block"
          alt="logo Aisc"
          src="@/assets/img/new-logo-aisc.png"
          max-height="80px"
          max-width="282px"
          @click="returnHome"
        />
        <div class="d-inline-block">
          <span class="powered"><i>powered by</i></span><br>
          <span class="powered-amplitudes">AMPLITUDES</span>
        </div>
      </button>
      <v-spacer />
      <div
        id="user-email"
      >
        <v-icon color="primary">
          mdi-account
        </v-icon>
        <span class="font-italic">
          {{ customer.email }}
        </span>
      </div>

      <v-dialog
        v-model="phoneContactDialogVisible"
        max-width="400px"
      >
        <template #activator="{on, attrs }">
          <v-btn
            height="100%"
            depressed
            text
            tile
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t('contact-us') }}
          </v-btn>
        </template>

        <v-card>
          <v-card-title>
            {{ $t('contact-dialog.title') }}
          </v-card-title>
          <v-card-text>
            <h3>
              {{ $t('contact-dialog.phone') }}
            </h3>
            <p>
              {{ $t('contact-dialog.amplitudes-phone') }}
            </p>
            <h3>
              {{ $t('contact-dialog.email') }}
            </h3>
            <p>
              <a :href="'mailto:' + $t('amplitudes-email')">
                {{ $t('contact-dialog.amplitudes-email') }}
              </a>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-menu
        offset-y
        close-on-click
        color="primary"
      >
        <template #activator="{on}">
          <v-btn
            class="mr-4"
            data-cy="button-header-language"
            height="100%"
            color="primary"
            text
            tile
            v-on="on"
          >
            <v-icon color="primary">
              mdi-web
            </v-icon>
            {{ $t('language') }}
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            data-cy="list-item-header-language-fr"
            @click="changeLanguage('fr')"
          >
            <v-img
              src="@/assets/img/flags/france.png"
              alt="French flag"
              height="32px"
              width="32px"
            />
            <v-list-item-title>{{ $t('fr') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            data-cy="list-item-header-language-en"
            @click="changeLanguage('en')"
          >
            <v-img
              src="@/assets/img/flags/united-kingdom.png"
              alt="French flag"
              height="32px"
              width="32px"
            />
            <v-list-item-title>{{ $t('en') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import globalMixin from '@/mixins/global'

export default {
  name: 'MainHeader',
  mixins: [globalMixin],
  data: () => ({
    mobileMenu: false,
    phoneContactDialogVisible: false
  }),
  computed: {
    ...mapGetters({
      customer: 'general/getCustomer'
    })
  },
  methods: {
    ...mapActions({
      returnHomeAction: 'general/returnHome'
    }),
    returnHome () {
      this.returnHomeAction()
      this.routerPushHome()
    },
    changeLanguage (language) {
      this.$root.$i18n.locale = language
      this.$root.$moment.locale(language)
    }
  }
}
</script>

<style scoped>
  #logo-aisc:hover {
    cursor: pointer;
  }

  header >>> .v-toolbar__content {
    padding: 0;
  }

  #user-email {
    margin-right: 20px;
  }

  .powered {
    font-size: 12px;
    color: #0057B8;
  }

  .powered-amplitudes {
    font-size: 12px;
    font-weight: bold;
  }
</style>
